import { onlyAllowAtoZFn, parseOnlyNumericValue, removeAllSpaces, removeMultipleSpace, removeSpecialCharAndNumFn1, removeUnderScrSpaceBet, sliceText } from "../../../utils/common";
import { safeString } from "../../../utils/logger";
const today = new Date().toISOString().split('T')[0];
const fiftyYearsAgo = new Date();
fiftyYearsAgo.setFullYear(fiftyYearsAgo.getFullYear() - 75);
const minDate = fiftyYearsAgo.toISOString().split('T')[0];
const todayDate = new Date();
const futureDate = new Date();
futureDate.setMonth(todayDate.getMonth() + 3);

// Adjust for months that exceed December
if (futureDate.getMonth() < todayDate.getMonth()) {
  futureDate.setFullYear(todayDate.getFullYear() + 1);
}

const maxDate = futureDate.toISOString().split('T')[0];


const minDOB = new Date();

// Subtract 18 years from today's date
minDOB.setFullYear(todayDate.getFullYear() - 18);

export const RELATION = {
  MARRIED: [
    { id: "wife", name: "Wife" },
    { id: "husband", name: "Husband" },
    { id: "brother", name: "Brother" },
    { id: "mother", name: "Mother" },
    { id: "father", name: "Father" },
  ],
  SINGLE: [
    { id: "brother", name: "Brother" },
    { id: "mother", name: "Mother" },
    { id: "father", name: "Father" },
  ],
  WIDOWED: [
    { id: "brother", name: "Brother" },
    { id: "mother", name: "Mother" },
    { id: "father", name: "Father" },
  ],
  DIVORCED: [
    { id: "brother", name: "Brother" },
    { id: "mother", name: "Mother" },
    { id: "father", name: "Father" },
  ],
};


export const EMPLOYEE_FORM_FIELDS = {
  // BASIC_INFORMATION: 
  "first_name": {
    name: "first_name",
    label: "First Name",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    required: true,
    customOptions: {
      formatValueFn: (value) => {
        // value = sliceText(onlyAllowAtoZFn(safeString(value).trim(), 150));
        value = sliceText(removeSpecialCharAndNumFn1(safeString(value), 150))
        return value;
      },
    },
  },
  "last_name": {
    name: "last_name",
    label: "Last Name",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    required: true,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(onlyAllowAtoZFn(safeString(value), 150));
        return value;
      },
    },

  },
  "phone": {
    name: "phone",
    label: "Contact Number",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    required: true,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(parseOnlyNumericValue(removeAllSpaces(value)), 10);
        return value;
      }
    }
  },
  "email": {
    name: "email",
    label: "Email Id",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    // required: true,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeUnderScrSpaceBet(value.toLowerCase()), 150);
        return value;
      }
    }
  },
  "alternative_phone": {
    name: "alternative_phone",
    label: "Alternate Contact Number",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(parseOnlyNumericValue(removeAllSpaces(value)), 10);
        return value;
      }
    }
  },
  personal_email: {
    name: "personal_email",
    label: "Personal Email",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeUnderScrSpaceBet(value.toLowerCase()), 150);
        return value;
      }
    }
  },

  // EMPLOYEE_DETAILS: 
  employment_type: {
    name: "employment_type",
    label: "Employment Type",
    inputType: "selectField",
    component: "SelectField",
    fullWidth: true,
    required: true,
    placeholder: "Select Here...",
    options: [
      { id: "full_time", name: "permanent" },
      { id: "part_time", name: "Part Time" },
      { id: "contractual", name: "Contractual" },
    ],
  },
  // employment_status: {
  //   name: "employment_status",
  //   label: "Employment Status",
  //   inputType: "selectField",
  //   component: "SelectField",
  //   fullWidth: true,
  //   required: true,
  //   placeholder: "Select Here...",
  //   options: [
  //     { id: "provisionperiod", name: "Provision Period" },
  //     { id: "permanent", name: "Permanent" },
  //   ],
  // },
  provision_period_days: {
    name: "provision_period_days",
    label: "Provision Period",
    required: true,
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(parseOnlyNumericValue(removeAllSpaces(value)), 3);
        return value;
      }
    }
  },
  join_date: {
    name: "join_date",
    label: "Joining Date",
    type: "date",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Select Here...",
    required: true,
    max: maxDate
  },
  contract_start: {
    name: "contract_start",
    label: "Contract Start",
    type: "date",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Select Here...",
    required: true,
    max: maxDate,
    min: today
  },
  contract_end: {
    name: "contract_end",
    label: "Contract End",
    type: "date",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Select Here...",
    required: true,
    max: maxDate,
    min: today
  },
  branch_id: {
    name: "branch_id",
    label: "Branch Name",
    inputType: "selectField",
    component: "SelectField",
    fullWidth: true,
    required: true,
    placeholder: "Select Here...",
    options: [
      { id: "newyork", name: "New York" },
      { id: "london", name: "London" },
    ],
  },
  designation_id: {
    name: "designation_id",
    label: "Designation",
    inputType: "selectField",
    component: "SelectField",
    fullWidth: true,
    // required: true,
    placeholder: "Select Here...",
    options: [
      { id: 1, name: "Software Engineer" },
      { id: 2, name: "HR Manager" },
      { id: 3, name: "Sales Associate" },
    ],
  },
  department_id: {
    name: "department_id",
    label: "Department",
    inputType: "selectField",
    component: "SelectField",
    fullWidth: true,
    // required: true,
    placeholder: "Select Here...",
    options: [
      { id: 1, name: "Marketing" },
      { id: 2, name: "Sales" },
      { id: 3, name: "IT" },
    ],
  },
  status: {
    name: "status",
    label: "Status",
    inputType: "selectField",
    component: "SelectField",
    fullWidth: true,
    placeholder: "Select Here...",
    options: [
      { id: "active", name: "Active" },
      { id: "inactive", name: "Inactive" },
      { id: "onboarding", name: "Onboarding" },
    ]
  },
  blood_group: {
    name: "blood_group",
    label: "Blood Group",
    inputType: "selectField",
    component: "SelectField",
    fullWidth: true,
    placeholder: "Select Here...",
    options: [
      { id: "A+", name: "A+" },
      { id: "A-", name: "A-" },
      { id: "B+", name: "B+" },
      { id: "B-", name: "B-" },
      { id: "O+", name: "O+" },
      { id: "O-", name: "O-" },
      { id: "AB+", name: "AB+" },
      { id: "AB-", name: "AB-" },
      { id: "other", name: "Other" },
    ],
  },


  // PERSONAL_INFORMATION : 
  date_of_birth: {
    name: "date_of_birth",
    label: "Date Of Birth",
    type: "date",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Select Here...",
    required: true,
    // max:maxDOB,

    min: minDate
  },
  gender: {
    name: "gender",
    label: "Gender",
    inputType: "selectField",
    component: "SelectField",
    fullWidth: true,
    required: true,
    placeholder: "Select Here...",
    options: [
      { id: "male", name: "Male" },
      { id: "female", name: "Female" },
      { id: "other", name: "Others" },
    ],
  },
  marital_status: {
    name: "marital_status",
    label: "Marital Status",
    inputType: "selectField",
    component: "SelectField",
    fullWidth: true,
    // required: true,
    placeholder: "Select Here...",
    options: [
      { id: "single", name: "Single" },
      { id: "married", name: "Married" },
      { id: "divorced", name: "Divorced" },
      { id: "widowed", name: "Widowed" },

    ],
  },
  guardian_relationship: {
    name: "guardian_relationship",
    label: "Relation With Guardian",
    inputType: "selectField",
    component: "SelectField",
    fullWidth: true,
    placeholder: "Select Here...",
    options: [
      { id: "father", name: "Father" },
      { id: "mother", name: "Mother" },
      { id: "uncle", name: "Uncle" },
      { id: "aunt", name: "Aunt" },
      { id: "spouse", name: "Spouse" },
      { id: "brother", name: "Brother" },
      { id: "sister", name: "Sister" },

    ],
  },
  

  guardian_name: {
    name: "guardian_name",
    label: "Guardian Name",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",

    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeSpecialCharAndNumFn1(safeString(value), 150));
        return value;
      },
    },
  },
shift_type: {
    name: "shift_type",
    label: "Shifts Type",
    inputType: "selectField",
    component: "SelectField",
    fullWidth: true,
    required: false,
    placeholder: "Select Here...",
    options: [
      { id: "morning", name: "Morning shift" },
      { id: "day", name: "Day shift" },
      { id: "afternoon", name: "Afternoon shifs" },
      { id: "night", name: "Night shift" },
      { id: "rotating", name: "Rotating shifs" },

    ],
  },
  permanent_address: {
    name: "permanent_address",
    label: "Address",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    // required: true,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeString(value)), 150);
        return value;
      }

    }
  },
  permanent_city: {
    name: "permanent_city",
    label: "City/District",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    // required: true,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeString(value
          .replace(/[^a-zA-Z0-9\s.-]/g, '') // allows letters, numbers, space, dot, hyphen
          .replace(/\s+/g, ' ')
        )), 150);
        return value;
      }
    }
  },

  permanent_country: {
    name: "permanent_country",
    label: "Country",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    // required: true,
    // disabled: true,
    options: [
      { id: "India", name: "India" },
      // { id: "china", name: "China" },
    ]
  },
  permanent_state: {
    name: "permanent_state",
    label: "State",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Select Here...",
    // required: true,
    options: [
      { id: "kolkata", name: "Kolkata" },
      { id: "mumbai", name: "Mumbai" },

    ],
  },
  permanent_pincode: {
    name: "permanent_pincode",
    label: "Pincode",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    // required: true,
    customOptions: {
      formatValueFn: (value) => {

        value = sliceText(parseOnlyNumericValue(safeString(value)), 6);
        return value;
      }

    }
  },
  permanent_landmark: {
    name: "permanent_landmark",
    label: "Landmark",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",

    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeString(value)), 150);
        return value;
      }

    }
  },
  permanent_location: {
    name: "permanent_location",
    label: "Landmark",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    // required: true,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeString(value)), 150);
        return value;
      }

    }
  },




  present_address: {
    name: "present_address",
    label: "Address",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    // required: true,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeString(value)), 150);
        return value;
      }

    }
  },
  present_city: {
    name: "present_city",
    label: "City/District",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    // required: true,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeString(value
          .replace(/[^a-zA-Z0-9\s.-]/g, '') // allows letters, numbers, space, dot, hyphen
          .replace(/\s+/g, ' ')
        )), 150);
        return value;
      }
    }
  },

  present_country: {
    name: "present_country",
    label: "Country",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    // required: true,
    // disabled: true,

    options: [
      { id: "India", name: "India" },
      // { id: "china", name: "China" },
    ]
  },
  present_state: {
    name: "present_state",
    label: "State",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Select Here...",
    // required: true,
    options: [
      { id: "kolkata", name: "Kolkata" },
      { id: "mumbai", name: "Mumbai" },

    ],

  },
  present_pincode: {
    name: "present_pincode",
    label: "Pincode",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    // required: true,
    customOptions: {
      formatValueFn: (value) => {

        value = sliceText(parseOnlyNumericValue(safeString(value)), 6);
        return value;
      }

    }
  },
  present_landmark: {
    name: "present_landmark",
    label: "Landmark",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",

    customOptions: {
      formatValueFn: (value) => {

        value = sliceText(removeMultipleSpace(safeString(value)), 150);
        return value;
      }

    }
  },
  salary_type: {
    name: "salary_type",
    label: "Salary Type",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Select Here...",
    required: true,
    options: [
      { id: "salary", name: "Salary" },
      { id: "wages", name: "Wages" },

    ],

  },
  // qualification: {
  //   name: "qualification",
  //   label: "Qualification",
  //   inputType: "selectField",
  //   component: "SelectField",
  //   fullWidth: true,
  //   required: false,
  //   placeholder: "Select Here...",
  //   options: [
  //     {
  //       id: "0001",
  //       name: "Non Educated",
  //     },
  //     {
  //       id: "0002",
  //       name: "Basic Education",
  //     },
  //     {
  //       id: "0003",
  //       name: "8th Standard",
  //     },
  //     {
  //       id: "0004",
  //       name: "10th Standard",
  //     },
  //     {
  //       id: "0005",
  //       name: "12th Standard",
  //     },
  //     {
  //       id: "0006",
  //       name: "Diploma",
  //     },
  //     {
  //       id: "0007",
  //       name: "Bachelor Degree",
  //     },
  //     {
  //       id: "0008",
  //       name: "Master Degree",
  //     },
  //     {
  //       id: "0009",
  //       name: "Doctor of Medicine",
  //     },
  //     {
  //       id: "0010",
  //       name: "Chartered Accountant",
  //     },
  //     {
  //       id: "0011",
  //       name: "Civil Engineering",
  //     },
  //     {
  //       id: "0012",
  //       name: "Mechanical Engineering",
  //     },
  //     {
  //       id: "0013",
  //       name: "Electrical Engineering",
  //     },
  //     {
  //       id: "0014",
  //       name: "Computer Science Engineering",
  //     },
  //     {
  //       id: "0015",
  //       name: "Bachelor of Engineering (BE)",
  //     },
  //     {
  //       id: "0016",
  //       name: "Bachelor of Technology (BTech)",
  //     },
  //     {
  //       id: "0017",
  //       name: "Information Technology (IT)",
  //     },
  //     {
  //       id: "0018",
  //       name: "Engineering",
  //     },
  //     {
  //       id: "0019",
  //       name: "Robotics & Automation",
  //     },
  //     {
  //       id: "0020",
  //       name: "PhD",
  //     },
  //   ],
  //   searchable:true,
  // }
  qualification: {
    name: "qualification",
    label: "Qualification",
    type: "text",
    inputType: "inputField",
    component: "InputField",
    fullWidth: true,
    placeholder: "Type Here...",
    required: false,
    customOptions: {
      formatValueFn: (value) => {
        value = sliceText(removeMultipleSpace(safeString(value)), 150);
        return value;
      }
    }
  },
};
export const EMPLOYEE_INITIAL_STATE = {
  employee_code: "",
  first_name: "",
  last_name: "",
  phone: "",
  alternative_phone: "",
  email: "",
  employment_type: "",
  provision_period_days: "",
  contract_start: "",
  contract_end: "",
  // contract_amount: "",
  branch_id: "",
  department_id: "",
  designation_id: "",
  date_of_birth: "",
  gender: "",
  blood_group: "",
  marital_status: "",
  join_date: "",
  status: "",
  is_new_hire: "",
  guardian_name: "",
  guardian_relationship: "",
  is_same_permanent: false,

  permanent_address: "",
  permanent_city: "",
  permanent_state: "",
  permanent_country: "India",
  permanent_pincode: "",
  permanent_landmark: "",

  present_address: "",
  present_city: "",
  present_state: "",
  present_country: "India",
  present_pincode: "",
  present_landmark: "",

  // employment_status: "test",
  // shifts: ""
  shift_type: null,
  salary_type: null
};
export const EMPLOYEE_PROFILE_MODAL = "EMPLOYEE_PROFILE_MODAL";
export const EMPLOYEE_PRESENT_ADDRESS_MODAL = "EMPLOYEE_PRESENT_ADDRESS_MODAL";
export const EMPLOYEE_INFORMATION_MODAL = "EMPLOYEE_INFORMATION_MODAL";
export const EMPLOYEE_DETAILS_MODAL = "EMPLOYEE_DETAILS_MODAL";
export const EMPLOYEE_PERMANENT_ADDRESS_MODAL = "EMPLOYEE_PERMANENT_ADDRESS_MODAL";

export const ALLOWANCE_ACT_STATE = {};
export const DATE_DEPENDANCY = ["contract_start", "contract_end", "join_date"];